var buttonSubmitm = $("#submit");
var buttonLoaderd = $("#flashmailchek");
var inputSub = $("#submit");
var inputEmailchek = $("#email");


function scanEmail(email) {
	inputEmailchek.val(email);
	buttonSubmitm.click();
}

$(function () {
	form.on('submit', function (e) {
		e.preventDefault();
		e.stopImmediatePropagation();

		buttonSubmitm.click();
	});

	buttonSubmitm.on('click', function () {
		buttonSubmitm.hide(); //bring back load more button
		buttonLoaderd.show();
		buttonLoaderd.fadeIn(400).html('<button class="btn btn-danger" disabled><span class="spinner-grow spinner-grow-sm"></span>	E-Mail-Adresse wird auf Verfügbarkeit geprüft..</button>');


		$.ajax({
			type: "POST",
			url: "/inc/email-checker.php",
			data: {
				email: inputEmailchek.val(),
				submit: inputSub.val(),
			},
			cache: false,
			success: function (html) {
				$("ol#results").prepend(html);
				$("ol#results li:first").slideDown("slow");
				buttonLoaderd.hide();
				buttonSubmitm.show();
			}
		});

		return false;
	});
});
